import { render, staticRenderFns } from "./OnboardingWizard.vue?vue&type=template&id=52f7aeb2&scoped=true&"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizard.vue?vue&type=style&index=0&id=52f7aeb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7aeb2",
  null
  
)

export default component.exports